export default __webpack_public_path__ + "static/media/photo--lg--kate.ed8107b5.jpg";